
let ipDirectSession = sessionStorage.getItem("ipredirect");

if (ipDirectSession != "Yonlendirildi") {
  sessionStorage.setItem("ipredirect", "Yonlendirildi");

  var data;
  var country;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer 4519e2e65f05cd");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  fetch("https://ipinfo.io", requestOptions)
    .then((response) => response.json())
    .then((data) => {
      obj = data;
    })
    .then((data) => {
      country = obj["country"];
    })
    .then(() => {
      if (country != "TR" && country != "DE") {
        var url = window.location.href;
        var newurl = url.replace("mineralistgumus.com", "mineralist.store");
        window.location.replace(newurl);
      }
    })
    .catch((error) => console.log("error", error));
  
}

